import { render, staticRenderFns } from "./gaugeProduct.vue?vue&type=template&id=4ad1f823&"
import script from "./gaugeProduct.vue?vue&type=script&lang=js&"
export * from "./gaugeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard})
